var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedIninline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97193 3.23727C4.97162 3.86344 4.72257 4.46383 4.27959 4.90638C3.8366 5.34892 3.23595 5.59737 2.60979 5.59705C1.98362 5.59674 1.38322 5.3477 0.940676 4.90471C0.498131 4.46172 0.249687 3.86107 0.25 3.23491C0.250313 2.60874 0.499357 2.00834 0.942346 1.5658C1.38533 1.12325 1.98598 0.874809 2.61215 0.875122C3.23831 0.875435 3.83871 1.12448 4.28126 1.56747C4.7238 2.01046 4.97224 2.6111 4.97193 3.23727ZM5.04276 7.34535H0.320829V22.125H5.04276V7.34535ZM12.5034 7.34535H7.80509V22.125H12.4562V14.3692C12.4562 10.0487 18.0871 9.64729 18.0871 14.3692V22.125H22.75V12.7638C22.75 5.48019 14.4158 5.7517 12.4562 9.32856L12.5034 7.34535Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedIninline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LinkedIn.inline.0790eec76486e25090654ed707c30a1b.svg";